export const updateProfileTranslations = {
  en: {
    editProfile: "Edit Profile",
    saveChanges: "Save Changes",
    saving: "Saving...",
    profile_updated_successfully: "Profile updated successfully",
    close: "Close",
    basicInfo: {
      firstName: "First Name",
      lastName: "Last Name",
      phone: "Phone",
      nationality: "Nationality",
      nationalityTooltip: "Enter your nationality or citizenship country.",
      residenceCountry: "Country",
      residenceCountryTooltip: "Select the country where you currently live.",
      residenceCountryPlaceholder: "Select country",
      profileImage: "Profile Image",
      bio: "Bio",
      bioTooltip: "Write a short profile bio.",
    },
    managerInfoSection: {
      organizationName: "Organization Name",
    },
    validation: {
      firstNameRequired: "First name is required",
      lastNameRequired: "Last name is required",
      residenceCountryRequired: "Country is required",
      nationalityRequired: "Nationality is required",
      bioLength: "Bio must be 1000 characters or less",
      imageFormat: "Only PNG and JPG images are supported",
      imageSize: "Image size must be less than 2MB",
      countryLoadFailed: "Failed to load countries",
      updateFailed: "Failed to update profile",
    },
  },
  de: {
    editProfile: "Edit Profile",
    saveChanges: "Save Changes",
    saving: "Saving...",
    profile_updated_successfully: "Profile updated successfully",
    close: "Close",
    basicInfo: {
      firstName: "First Name",
      lastName: "Last Name",
      phone: "Phone",
      nationality: "Nationality",
      nationalityTooltip: "Enter your nationality or citizenship country.",
      residenceCountry: "Country",
      residenceCountryTooltip: "Select the country where you currently live.",
      residenceCountryPlaceholder: "Select country",
      profileImage: "Profile Image",
      bio: "Bio",
      bioTooltip: "Write a short profile bio.",
    },
    managerInfoSection: {
      organizationName: "Organization Name",
    },
    validation: {
      firstNameRequired: "First name is required",
      lastNameRequired: "Last name is required",
      residenceCountryRequired: "Country is required",
      nationalityRequired: "Nationality is required",
      bioLength: "Bio must be 1000 characters or less",
      imageFormat: "Only PNG and JPG images are supported",
      imageSize: "Image size must be less than 2MB",
      countryLoadFailed: "Failed to load countries",
      updateFailed: "Failed to update profile",
    },
  },
  hr: {
    editProfile: "Edit Profile",
    saveChanges: "Save Changes",
    saving: "Saving...",
    profile_updated_successfully: "Profile updated successfully",
    close: "Close",
    basicInfo: {
      firstName: "First Name",
      lastName: "Last Name",
      phone: "Phone",
      nationality: "Nationality",
      nationalityTooltip: "Enter your nationality or citizenship country.",
      residenceCountry: "Country",
      residenceCountryTooltip: "Select the country where you currently live.",
      residenceCountryPlaceholder: "Select country",
      profileImage: "Profile Image",
      bio: "Bio",
      bioTooltip: "Write a short profile bio.",
    },
    managerInfoSection: {
      organizationName: "Organization Name",
    },
    validation: {
      firstNameRequired: "First name is required",
      lastNameRequired: "Last name is required",
      residenceCountryRequired: "Country is required",
      nationalityRequired: "Nationality is required",
      bioLength: "Bio must be 1000 characters or less",
      imageFormat: "Only PNG and JPG images are supported",
      imageSize: "Image size must be less than 2MB",
      countryLoadFailed: "Failed to load countries",
      updateFailed: "Failed to update profile",
    },
  },
};
